export const getRequiredOptionIds = (component) => {
  return component.component?.conditional?.onOptionIds || [];
};

export const getComponentIdsRequiringOtherSelection = (component) =>
  component.component?.conditional?.onComponentIdsOfOtherOptions || [];

export const getValidationConstraintsArray = (component) => {
  const { constraints } = component.validation;
  return Object.keys(constraints).filter(
    (constraint) => constraint !== 'preventPlaceholderValue'
  );
};

export const findComponentByFieldName = (fieldName, fieldValue, state) => {
  const foundComponentOrError = {};
  if (state && state.formSettings && state.formSettings.page_components) {
    const componentObjectsMap = state.formSettings.page_components;
    const keyOfSearchedComponentObject = Object.keys(componentObjectsMap).find(
      (componentObjectKey) => {
        const { component } = componentObjectsMap[componentObjectKey];
        if (component && component.mappedQuestionId === fieldName) {
          return true;
        }
        if (component && component.text === fieldName) {
          return true;
        }
        return false;
      }
    );

    const foundComponentObject =
      componentObjectsMap[keyOfSearchedComponentObject];
    if (foundComponentObject) {
      foundComponentOrError.componentId = foundComponentObject.component.id;
      foundComponentOrError.fieldType = foundComponentObject.component.type;
      /* For radio button fields, checkboxes and select dropdown fields, an
       exact match of the provided fieldValue with one of the valid options
       needs to be verified, as the value wouldn't have any effect on the UI.
       For all other fields, invalid values will be caught by the server-side
       form validations. It would be inefficient to bulk-validate them all here.
      */
      if (
        ['radios', 'select', 'checkboxes'].includes(
          foundComponentObject.component.type
        )
      ) {
        const selectedOption = foundComponentObject.input.options.find(
          (option) => option.key === fieldValue || option.value === fieldValue
        );
        if (selectedOption) {
          foundComponentOrError.optionId = String(selectedOption.id);
        } else {
          foundComponentOrError.errorObject = {
            message:
              `The provided key-value pair '${fieldName}' => ` +
              `'${fieldValue}' caused an error:\n` +
              'No valid question option could be found for the value' +
              `'${fieldValue}'\n` +
              'The identified question is:\n' +
              `'${foundComponentObject.component.text}'`,
            operation: 'Send data into loaded form widget',
          };
        }
      }
    } else {
      foundComponentOrError.errorObject = {
        message:
          `The provided key-value pair '${fieldName}' => ` +
          `'${fieldValue}' caused an error:\n` +
          'No correspondent question could be found on this form for the key' +
          `'${fieldName}'\n`,
        operation: 'Send data into loaded form widget',
      };
    }
    return foundComponentOrError;
  }
  return undefined;
};

export const getPreSubmissionComponents = (
  components,
  submissionPageNumber
) => {
  if (typeof submissionPageNumber === 'number') {
    const filteredComponents = Object.values(components).filter((component) => {
      const { page } = component.component;
      return page <= submissionPageNumber;
    });

    return filteredComponents.reduce((acc, component) => {
      // eslint-disable-next-line no-param-reassign
      acc[`component_${component.component.id}`] = component;
      return acc;
    }, {});
  }

  return components;
};
